import Stack from '@mui/material/Stack'

import { MultilineChart } from '@mxenabled/mx-icons'

import { P } from '@mxenabled/mxui'

import { observer } from 'mobx-react-lite'

import { useGlobalCopyStore } from '../common'

export const ZeroStateMicroWidget = observer(() => {
  const { trends: copy } = useGlobalCopyStore()

  return (
    <Stack sx={{ alignItems: 'start', flexDirection: 'row', gap: 12 }}>
      <MultilineChart size={32} />
      <Stack>
        <P fontWeight={600} variant="body1">
          {copy.zero_state_content_header}
        </P>
        <P color="text.secondary" variant="subtitle2">
          {copy.zero_state_content_description}
        </P>
      </Stack>
    </Stack>
  )
})
